import { createFrontendModule, PageBlueprint } from '@backstage/frontend-plugin-api';
import { HomePage } from '@internal/backstage-plugin-catalog-devops';

/**
 * The home page route. Previously this lived as a PageBlueprint in
 * catalog-devops (design/pages.tsx); it moved here together with the
 * redesigned HomePage (design/homepage-mockup.html).
 */
export const homeModule = createFrontendModule({
  pluginId: 'app',
  extensions: [
    PageBlueprint.make({
      params: {
        path: '/',
        loader: async () => <HomePage />,
      },
    }),
  ],
});
